import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "contact_mail_24px",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon/communication/contact_mail_24px",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 3H22C23.1 3 24 3.9 24 5L23.99 19C23.99 20.1 23.1 21 22 21H2C0.9 21 0 20.1 0 19V5C0 3.9 0.9 3 2 3ZM2 19H22V5H2V19ZM21 6H14V11H21V6ZM17.5 9.75L20 8V7L17.5 8.75L15 7V8L17.5 9.75ZM9 12C10.65 12 12 10.65 12 9C12 7.35 10.65 6 9 6C7.35 6 6 7.35 6 9C6 10.65 7.35 12 9 12ZM10 9C10 8.45 9.55 8 9 8C8.45 8 8 8.45 8 9C8 9.55 8.45 10 9 10C9.55 10 10 9.55 10 9ZM15 16.59C15 14.09 11.03 13.01 9 13.01C6.97 13.01 3 14.09 3 16.59V18H15V16.59ZM9 15C7.7 15 6.22 15.5 5.48 16H12.52C11.77 15.49 10.3 15 9 15Z",
			fill: "#2771bb"
		})
	})]
});
const ForwardRef = forwardRef(SvgMail);
export default ForwardRef;
